var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"contenedor"},[_c('div',{staticClass:"ancho-max"},[_c('div',[_c('a',{staticClass:"marca",attrs:{"href":"https://tirandocodigo.mx/"}},[_c('strong',[_vm._v("Tirando Código")])])])])])
}]

export { render, staticRenderFns }